<script setup lang="ts">
import { OctagonAlert, TriangleAlert } from '@lucide/vue'
import { enterpriseBillingAlertLabel } from '@zerohuman/shared'
import { ZhTooltip } from '@zerohuman/ui'
import { computed } from 'vue'
import type { EnterpriseBillingAlert } from '@/api'

/**
 * The enterprise picker's billing flag on one enterprise, in the tone its own banner would take: magenta where the
 * plan is past due or a limit has paused work, amber where a limit is coming close. The shapes differ as well as the
 * hues, so the two never rest on colour alone. Renders nothing for an enterprise Billing has nothing to say about.
 */
const props = defineProps<{ alert?: EnterpriseBillingAlert | null }>()

const label = computed(() => (props.alert ? enterpriseBillingAlertLabel(props.alert) : ''))
</script>

<template>
	<ZhTooltip v-if="alert" :text="label">
		<span
			role="img"
			class="inline-flex shrink-0"
			:class="alert.tone === 'blocked' ? 'text-state-failed' : 'text-warning-amber'"
			:aria-label="label"
			data-testid="billing-alert"
			:data-tone="alert.tone"
		>
			<OctagonAlert v-if="alert.tone === 'blocked'" class="size-4" aria-hidden="true" />
			<TriangleAlert v-else class="size-4" aria-hidden="true" />
		</span>
	</ZhTooltip>
</template>
